import type { StateCreator } from 'zustand';

import type { AppSlice, GlobalStore } from '../schema';

const IS_STAGING = 'isStaging';

export const createAppSlice: StateCreator<
  GlobalStore,
  [['zustand/devtools', never]],
  [],
  AppSlice
> = (set) => ({
  isStaging: localStorage.getItem(IS_STAGING) === 'true',
  setIsStaging: (isStaging) => {
    localStorage.setItem(IS_STAGING, `${isStaging}`);
    set({ isStaging }, false, 'app/setIsStaging');
  },
});
